module.exports = __webpack_public_path__ + "static/view-page-e77bc59a1882091a2a8aaa8244551352.png";